import * as CONST from '../common/const';
import api from 'utils/api';
import {saveJobsDataSuccess} from "./fetchJobsData";

export const saveCalcDetailsDataRequest = () => {
  return {
    type: CONST.SAVE_CALCDETAILS_REQUEST
  }
}

export const saveCalcDetailDataSuccess = () => {
  return {
    type: CONST.SAVE_CALCDETAILS_SUCCESS,
  }
}

export const saveCalcDetailDataFailure = (error) => {
  return {
    type: CONST.SAVE_CALCDETAILS_FAILURE,
    error: error,
  };
};


export const saveCalcDetailsData = (id, payload) => async (dispatch, getState) => {
  dispatch(saveCalcDetailsDataRequest());
  try {
    const newPayload = JSON.stringify(payload);
    await api.saveCalcDetailData(id, newPayload);
    dispatch(saveCalcDetailDataSuccess());
    dispatch(saveJobsDataSuccess(id, newPayload))
  } catch (e) {
    dispatch(saveCalcDetailDataFailure(e));
  }
};